<template>
  <v-row class="pt-0">
    <v-col cols="12 pb-0 pt-0">
      <v-row class="d-print-none">
        <v-col
          cols="12"
          md="1"
          sm="6"
        >
          <v-btn
            class="info"
            @click="$router.push({ name: 'Dashboard' })"
          >
            <v-icon>mdi-home-outline</v-icon>
          </v-btn>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="6"
        >
          <v-autocomplete
            ref="searchInput"
            v-model.trim="searchModel"
            :search-input.sync="search"
            :items="suggestions"
            item-text="title"
            return-object
            prepend-inner-icon="mdi-barcode-scan"
            outlined
            clearable
            counter
            autofocus
            rounded
            auto-select-first
            label="Search or Scan"
            dense
            :color="searchLock ? 'success' : 'info'"
            hide-details="auto"
            :loading="searchLock"
            :disabled="isRefunding || searchLock"
            @blur="setFocusIntervel"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
          <v-autocomplete
            v-model="customer"
            :items="customers"
            item-text="firstName"
            item-value="id"
            prepend-inner-icon="mdi-account"
            outlined
            clearable
            label="Customer"
            dense
            rounded
            hide-details="auto"
            :disabled="isRefunding"
            @change="setCustomer"
          />
        </v-col>
        <v-col
          cols="12"
          md="1"
          sm="6"
          class="pl-0 ml-0 d-flex"
        >
          <v-btn
            class="error"
            @click="isRefunding = !isRefunding"
          >
            <v-icon>mdi-cart-off</v-icon>
          </v-btn>
          <v-btn
            class="warning ml-2"
            @click="addModel = true"
          >
            <v-icon>mdi-shape-rectangle-plus</v-icon>
          </v-btn>

          <v-btn
            class="info ml-2"
            @click="advanceSearchModel = true"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <template v-if="isRefunding">
      <sale-return />
    </template>
    <template v-else>
      <template v-if="sold">
        <v-col cols="12">
          <sale-success />
        </v-col>
      </template>
      <template v-else>
        <v-col
          cols="12"
          md="7"
          sm="6"
          class="text-center pb-0 pt-0 "
        >
          <products />
        </v-col>
        <v-col
          cols="12"
          md="5"
          sm="6"
          class="pb-0 pt-0"
        >
          <cart />
        </v-col>
      </template>
    </template>

    <!-- Add repair model -->
    <v-dialog
      v-model="addModel"
      fullscreen
      persistent
      max-width="75%"
    >
      <v-card>
        <v-card-actions class="pr-9">
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="closeModels"
          >
            Close
          </v-btn>
        </v-card-actions>
        <v-card-text class="pt-0">
          <v-tabs>
            <v-tab>Add Repair</v-tab>
            <v-tab>New Bill</v-tab>
            <v-tab>Buy From Customer</v-tab>
            <v-tab>New Customer</v-tab>
            <v-tab-item><repair-form /></v-tab-item>
            <v-tab-item><bill-form /></v-tab-item>
            <v-tab-item><custom-product /></v-tab-item>
            <v-tab-item><customer-new /></v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- warning ends -->

    <!-- Add repair model -->
    <v-dialog
      v-model="advanceSearchModel"
      fullscreen
      persistent
    >
      <v-card>
        <v-card-actions class="pr-9">
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="closeModels"
          >
            Close
          </v-btn>
        </v-card-actions>
        <v-card-text class="pt-0 mt-0">
          <advance-search />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- warning ends -->
  </v-row>
</template>

<script>
import Products from "./Products.vue";
import Cart from "./Cart.vue";
import SaleSuccess from "./SaleSuccess.vue";
import Refund from "./Refund.vue";
import RepairForm from "../repair/RepairForm.vue";
import BillForm from "../bill/BillForm.vue";
import AdvanceSearch from "../searching/AdvanceSearch.vue";
import CustomProductForm from "../customBuy/CustomProduct.vue";
import CustomerNew from "../contacts/CustomerForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    products: Products,
    cart: Cart,
    "sale-success": SaleSuccess,
    "sale-return": Refund,
    "repair-form": RepairForm,
    "bill-form": BillForm,
    "advance-search": AdvanceSearch,
    "custom-product": CustomProductForm,
    "customer-new": CustomerNew,
  },

  data() {
    return {
      advanceSearchModel: false,
      stopFocusing: false,
      addModel: false,
      searchLock: false,
      search: "",
      searchModel: null,
      suggestionsOrg: [],
      isRefunding: false,
      sold: false,
      customers: [],
      customer: "",
      form: {},
    };
  },
  computed: {
    ...mapGetters({
      main: "configs/overall",
    }),
    checkModelisActive() {
      return this.advanceSearchModel || this.addModel || this.stopFocusing;
    },
    suggestions() {
      const list = this.$data.suggestionsOrg;
      if (list !== null) {
        list.map((item) => {
          item.title = item.name + " | " + item.sku + " | " + item.barcode;
        });
      }
      return list;
    },
  },
  watch: {
    isRefunding() {
      if (!this.isRefunding) {
        this.setFocusIntervel();
      }
    },
    search(val) {
      if (val !== null) {
        this.searchOperation(this.suggestions);
      }
    },
  },
  created() {
    Event.$on("prepareSearchSuggestions", (products) => {
      this.$data.suggestionsOrg = products;
    });
    Event.$on("stopFocusingStateChange", () => {
      this.$data.stopFocusing = !this.stopFocusing;
      this.setFocusIntervel();
    });
    Event.$on("salePlaced", () => {
      this.$data.sold = !this.$data.sold;
    });
  },
  mounted() {
    this.$refs.searchInput.focus();
    if (this.$route.params.trax) {
      this.$data.isRefunding = true;
    }
    window.axios.get("/customers-for-pos").then((response) => {
      this.$data.customers = response.data.customers;
    });
  },
  methods: {
    ...mapActions({
      addToCart: "cart/add",
    }),
    closeModels() {
      this.advanceSearchModel = false;
      this.addModel = false;
      this.$refs.scanSearch.focus();
    },
    setFocusIntervel() {
      if (!this.checkModelisActive) {
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, this.main.focusIntervel);
      }
    },
    searchOperation(suggestions) {
      const key = this.$data.search;
      if (
        key.match(/[a-z]/i) == null &&
        key.length == this.main.barcodeContainsDigits
      ) {
        suggestions.find((suggestion) => {
          if (suggestion.barcode === key) {
            this.searchLock = true;
            this.addToCart(suggestion);
          }
          setTimeout(() => {
            this.$data.search = null;
            this.searchLock = false;
            this.$refs.searchInput.focus();
          }, this.main.scanningSensitivity);
        });
      }
      if (this.searchModel !== null) {
        this.addToCart(this.$data.searchModel);
      }
      this.$nextTick(() => {
        this.$data.searchModel = null;
      });
    },

    setCustomer() {
      Event.$emit("saleCustomer", this.$data.customer);
    },
  },
};
</script>
